import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SyncLoader } from 'react-spinners'
import { animate, motion, useMotionValue } from 'framer-motion'

import DataTestId from 'meta/dataTestId'
import { TICKETSMS_COLORS_BLACK, TICKETSMS_COLORS_RED, TICKETSMS_COLORS_WHITE } from 'utils/constants/colors'

import Img from 'components/Media/Img'

interface Props {
  onDragComplete(): void
  isTicketDrink: boolean
  totalTickets?: number
}

const DraggableBox: React.FC<Props> = (props) => {
  const { onDragComplete } = props

  const { t } = useTranslation()

  const x = useMotionValue(-249)
  const [isDragComplete, setIsDragComplete] = useState(false)

  const MAX_LEFT = 0
  const MIN_LEFT = -249

  const handleDragEnd = () => {
    const currentX = x.get()

    if (currentX >= MAX_LEFT - 32) {
      x.set(MAX_LEFT)
      if (!isDragComplete) {
        setIsDragComplete(true)
        onDragComplete()
      }
    } else {
      animate(x, MIN_LEFT, {
        type: 'spring',
        stiffness: 300,
        damping: 25,
      })
    }
  }

  return (
    <div
      style={{
        width: 313,
        height: 64,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: 'white',
        borderRadius: 64,
      }}
    >
      <motion.div
        drag={isDragComplete ? false : 'x'}
        dragConstraints={{ left: MIN_LEFT, right: MAX_LEFT }}
        style={{
          width: 313,
          height: 64,
          backgroundColor: TICKETSMS_COLORS_RED,
          position: 'absolute',
          zIndex: 3,
          top: 0,
          x,
          cursor: 'grab',
          borderRadius: 64,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        whileTap={{ scale: isDragComplete ? 1 : 0.97 }}
        onDragEnd={handleDragEnd}
      >
        {!isDragComplete && (
          <>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 16,
                color: 'white',
                marginLeft: 32,
              }}
            >
              {`${t('goodsAndServices:warning_invalidating_articles')}`}
            </div>
            <div style={{ width: 48, height: 32 }}>
              <Img
                style={{
                  pointerEvents: 'none',
                }}
                src="/goodsandservices/warning-octagon.svg"
                data-testid={DataTestId.bag.tap2GoSwiperArrowRight}
              />
            </div>
          </>
        )}
        {isDragComplete && (
          <div
            style={{
              position: 'absolute',
              zIndex: 3,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%,-50%)',
            }}
          >
            <SyncLoader size={8} color={TICKETSMS_COLORS_WHITE} />
          </div>
        )}
      </motion.div>
      <div
        style={{
          position: 'absolute',
          zIndex: 1,
          color: TICKETSMS_COLORS_BLACK,
          top: 0,
          left: 0,
          width: 313,
          height: 64,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 'bold',
          fontSize: 14,
        }}
      >
        <span style={{ marginLeft: 44 }}>{`${t('goodsAndServices:show_screen_to_staff')}`}</span>
      </div>
    </div>
  )
}

export default DraggableBox
